import { BookingDataService } from './../service/data/booking-data.service';
import { DeceasedProfile } from './../models/DeceasedProfile';
import { QueueTicket } from './../models/QueueTicket';
import { Booking } from './../models/booking';
import { Router } from '@angular/router';
import { Account } from './../models/account';
import { AccountDataService } from './../service/data/account-data.service';
import { BasicAuthenticationService } from './../auth/basic-authentication.service';
import { UserDataService } from './../service/data/user-data.service';
import { SystemConfig } from './../models/SystemConfig';
import {
  OBS_IS_UNDER_MAINTENANCE,
  IN_OPERATION_MODE,
  IN_MAINTENANCE_MODE
} from './../app.constant';
import { SystemDataService } from './../service/data/system-data.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BookingHistory } from '../models/BookingHistory';

@Component({
  selector: 'app-book-history',
  templateUrl: './book-history.component.html',
  styleUrls: ['./book-history.component.css']
})
export class BookHistoryComponent implements OnInit {
  //Inital Column
  displayedColumns = [
    'bk_date',
    'acc_name',
    'bk_time',
    'deceased_name',
    'status'
  ];

  loginAccount: Account;
  allAccounts: Account[];
  idDropDownDisabled: boolean;
  currentSelectedAccount: Account;

  allOptionIsAvailable = false;

  bookingViewArray: BookingHistoryView[];

  constructor(
    private systemDataService: SystemDataService,
    private accountDataService: AccountDataService,
    private basicAuthenticationService: BasicAuthenticationService,
    private bookingDataService: BookingDataService,
    private changeDetectorRefs: ChangeDetectorRef,
    private router: Router
  ) { }

  ngOnInit() {
    this.initialise();
  }

  async initialise() {
    this.allAccounts = [];

    let response = await this.getMaintenanceStatus();

    var firstKey = Object.keys(response)[0];

    var systemConfig: SystemConfig;

    if (firstKey.toUpperCase() == 'OK') {
      systemConfig = response[firstKey];

      if (systemConfig.value == IN_OPERATION_MODE) {
        // Get current login account

        let response = await this.getAccount(
          this.basicAuthenticationService.getAuthenticatedUser()
        );

        var firstKey = Object.keys(response)[0];

        if (firstKey.toUpperCase() == 'OK') {
          this.loginAccount = response[firstKey];

          this.allAccounts.push(this.loginAccount);

          if (!this.isMainAccount(this.loginAccount)) {
            this.idDropDownDisabled = true;
            this.refreshBookings([this.loginAccount.accountId]);
          } else {
            this.idDropDownDisabled = false;
            this.allOptionIsAvailable = true;

            await this.pushSubAccountsIntoAllAccountVariable(
              this.loginAccount.accountId
            );

            const accountIdArray = this.allAccounts.map(a => a.accountId);

            console.log("accountIdArray " + accountIdArray);

            this.refreshBookings(accountIdArray);
          }
        }
      } else if (systemConfig.value == IN_MAINTENANCE_MODE) {
        this.basicAuthenticationService.clearSession();
        this.router.navigate(['maintenance']);
      }
    } else if (firstKey.toUpperCase() == 'ERROR') {
    }
  }

  private isMainAccount(account: Account): boolean {
    return account.accountId == account.mainAccountId;
  }

  bookingHistList: BookingHistory[] = [];

  private refreshBookings(accountIdList: string[]) {
    this.bookingViewArray = [];

    accountIdList.forEach(accountId => {

      let searchStartDate = new Date();
      searchStartDate.setFullYear(2018);

      let searchEndDate = new Date();

      this.bookingDataService
        .getBookingHistoryView(searchStartDate, searchEndDate, '', accountId, '')
        .subscribe(
          response => {

            const firstKey = Object.keys(response)[0];

            if (firstKey.toUpperCase() === 'OK') {


              this.bookingHistList = response[firstKey];

              for (var _i = 0; _i < this.bookingHistList.length; _i++) {
               
                let sameId = -1;

                for (var _j = 0; _j < this.bookingViewArray.length; _j++) {
               
                  if(this.bookingHistList[_i].bookingId===
                    this.bookingViewArray[_j].bookingId){

                      sameId = _j;
                  }
                }

                if(sameId==-1){
                  var bookingHistoryView: BookingHistoryView = {
                  bookingId : this.bookingHistList[_i].bookingId,
                  bookingTimeFrom : new Date(this.bookingHistList[_i].bookingTimeFrom),
                  bookingStartDateLocaleString : new Date(this.bookingHistList[_i].bookingTimeFrom).toLocaleDateString(),
                  bookingStartTimeLocaleString : new Date(this.bookingHistList[_i].bookingTimeFrom).toLocaleTimeString(),
                  fullName : this.bookingHistList[_i].fullName,
                  deceasedNameString : this.bookingHistList[_i].deceasedName,
                  status : this.bookingHistList[_i].status
                  }
                  this.bookingViewArray.push(bookingHistoryView);
                }
                else{

                  if(!this.bookingViewArray[sameId].deceasedNameString.includes(this.bookingHistList[_i].deceasedName))
                    this.bookingViewArray[sameId].deceasedNameString += ", " + this.bookingHistList[_i].deceasedName;
                }
                  
              }



              console.log(this.bookingViewArray);

              this.bookingViewArray = [...this.bookingViewArray];

              //this.bookingViewArray.sort((a, b) => (a.booking.bookingTimeFrom > b.booking.bookingTimeFrom) ? -1 : 1)

              this.changeDetectorRefs.detectChanges();
            } else if (firstKey.toUpperCase() == 'ERROR') {
              // this.showAlertMessage(
              //   'Error occurred.',
              //   this.DASHBOARD_ALERT_TOP_POSITION
              // );
            }
          },
          error => {
            console.log(error);
          }
        );
    });
  }

  public getMaintenanceStatus(): Promise<any> {
    return this.systemDataService
      .getSystemConfig(OBS_IS_UNDER_MAINTENANCE)
      .toPromise();
  }

  public getSubAccountByMainAccountId(mainAccountId: string): Promise<any> {
    return this.accountDataService
      .getSubAccountByMainAccountId(mainAccountId)
      .toPromise();
  }

  async pushSubAccountsIntoAllAccountVariable(mainAccountId: string) {

    let subAccounts: Account[];

    let response = await this.getSubAccountByMainAccountId(mainAccountId);

    var firstKey = Object.keys(response)[0];

    if (firstKey.toUpperCase() == 'OK') {
      subAccounts = response[firstKey];

      subAccounts.forEach(subAccount => {
        this.allAccounts.push(subAccount);
      });

    } else if (firstKey.toUpperCase() == 'ERROR') {

    }

    console.log("pushSubAccountsIntoAllAccountVariable" + JSON.stringify(this.allAccounts));
  }

  public getAccount(accountId: string): Promise<any> {
    return this.accountDataService.getAccount(accountId).toPromise();
  }

  accountName = "";



  public idSelectedInDropDownList(idSelected: string) {

    if (idSelected.toUpperCase() == 'ALL') {

      this.accountName = "";

      this.refreshBookings(this.allAccounts.map(a => a.accountId));
    }
    else {
      this.refreshBookings([idSelected]);

      this.accountName = this.allAccounts.find( a => a.accountId == idSelected).fullName;
    }



  }
}

export interface BookingHistoryView {

  bookingId: string;

  bookingTimeFrom: Date;
  fullName: string;
  status: string;
  deceasedNameString: string;
  bookingStartDateLocaleString: string;
  bookingStartTimeLocaleString: string;
};
